var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperclip1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C11.2386 2 9 4.23858 9 7V14.875C9 16.4628 10.2872 17.75 11.875 17.75C13.4628 17.75 14.75 16.4628 14.75 14.875V7.75C14.75 7.33579 14.4142 7 14 7C13.5858 7 13.25 7.33579 13.25 7.75V14.875C13.25 15.6344 12.6344 16.25 11.875 16.25C11.1156 16.25 10.5 15.6344 10.5 14.875V7C10.5 5.067 12.067 3.5 14 3.5C15.933 3.5 17.5 5.067 17.5 7V15.25C17.5 18.1495 15.1495 20.5 12.25 20.5H11.75C8.8505 20.5 6.5 18.1495 6.5 15.25V10.75C6.5 10.3358 6.16421 10 5.75 10C5.33579 10 5 10.3358 5 10.75V15.25C5 18.9779 8.02208 22 11.75 22H12.25C15.9779 22 19 18.9779 19 15.25V7C19 4.23858 16.7614 2 14 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip1);
export default __webpack_public_path__ + "static/media/paperclip-1.81236cebee9d164ca4dea0e7d1bdc79f.svg";
export { ForwardRef as ReactComponent };